import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useAuth = () => {
  const [accessToken, setAccessToken] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // New auth flow stores the bearer under `accessToken`; legacy userData may
    // still carry `access_token` until the old session expires.
    const token =
      localStorage.getItem("accessToken") ||
      (JSON.parse(localStorage.getItem("userData") || "{}") || {}).access_token;
    setAccessToken(token || null);
  }, []);

  useEffect(() => {
    const handleUnauthorized = (event) => {
      if (event.detail.status === 401 || !accessToken) {
        console.error(accessToken ? "unauthorized access" : "No access token");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userData");
        navigate("/login");
      }
    };

    window.addEventListener("unauthorized", handleUnauthorized);
    return () => window.removeEventListener("unauthorized", handleUnauthorized);
  }, [navigate]);

  return { accessToken, setAccessToken };
};
